'use client'

import { useEffect } from 'react'
import Link from 'next/link'

interface AuthPromptModalProps {
  open: boolean
  onClose: () => void
  entityName?: string
}

export function AuthPromptModal({ open, onClose, entityName }: AuthPromptModalProps) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="auth-prompt-title"
    >
      <button
        type="button"
        className="absolute inset-0 bg-slate-900/50"
        aria-label="Close"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-2xl">
        <h2 id="auth-prompt-title" className="text-xl font-bold text-[#1E4289] mb-2">
          Save your rating
        </h2>
        <p className="text-sm text-slate-600 mb-6">
          {entityName
            ? `Your rating for ${entityName} is saved in this browser. Create an account or log in to keep it and continue rating.`
            : 'Your rating is saved in this browser. Create an account or log in to keep it and continue rating.'}
        </p>
        <div className="flex flex-col gap-3">
          <Link
            href="/auth/signup"
            className="w-full text-center px-4 py-3 bg-[#1E4289] text-white rounded-lg hover:bg-[#FEDB1A] hover:text-slate-900 font-bold transition-colors"
          >
            Create an account
          </Link>
          <Link
            href="/auth/signin"
            className="w-full text-center px-4 py-3 border border-[#1E4289] text-[#1E4289] rounded-lg hover:bg-[#1E4289]/5 font-semibold transition-colors"
          >
            Log in
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-slate-500 hover:text-slate-700 py-1"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  )
}
